import { HttpClient, IHttpResponseMessage } from '@mosaik/core';
import { SurveyResult } from '../models/survey-result.model';

export class SurveyService {
  private readonly _httpClient: HttpClient;

  public constructor() {
    this._httpClient = new HttpClient();
  }

  public async survey(result: SurveyResult): Promise<IHttpResponseMessage> {
    this._httpClient.configure({
      headers: {
        'X-Survey': result.hash
      },
      method: 'POST',
      body: JSON.stringify(result)
    });
    return this._httpClient.post('/HelplineServer/api/Survey/SurveyResult');
  }
}
